export const EmployeeContractActionBarEN = {
    "employeeContractActionBar": {
        "header": {
            "detail": "Contract Details"
        },
        "tab": {
            "detail": "Detail",
            "fileAttach": "Attachments"
        },
        "item": {
            "delete": "Delete",
            "auditing": "Activity History",
            "update": "Update",
            "approval": "Approve",
            "back": "Go Back"
        },
        "message": {
            "deleteAsk": "Are you sure you want to delete?",
            "approvalAsk": "Are you sure you want to approve the contract?"
        }
    }
}